import {
  ButtonLayoutValue,
  ButtonObjectType,
  DashboardButtons,
  DriverOptionsLandscapeButtons,
} from './types';

export const EditorButtonsDashboard: ButtonObjectType[] = [
  {
    name: 'Recap',
    key: 'RECAP',
    cssClass: 'dropped mainDashboard',
  },
  {
    name: 'Roadside Inspection',
    key: 'ROADSIDE_INSPECTION',
    cssClass: 'dropped mainDashboard',
  },
  {
    name: 'Options',
    key: 'OPTIONS',
    cssClass: 'dropped mainDashboard',
  },
  {
    name: 'Logs',
    key: 'LOGS',
    cssClass: 'dropped mainDashboard',
  },
  {
    name: 'Shift / Cycle',
    key: 'SHIFT_CYCLE',
    cssClass: 'dropped mainDashboard',
  },
  {
    name: 'DVIR',
    key: 'DVIR',
    cssClass: 'dropped mainDashboard',
  },
];

export const defaultTemplateDashBoard: DashboardButtons = {
  dashboard_btn0: {
    name: 'Recap',
    key: 'RECAP',
    cssClass: 'portrait-dropped mainDashboard',
  },
  dashboard_btn1: {
    name: 'Roadside Inspection',
    key: 'ROADSIDE_INSPECTION',
    cssClass: 'portrait-dropped mainDashboard',
  },
  dashboard_btn2: {
    name: 'Options',
    key: 'OPTIONS',
    cssClass: 'portrait-dropped mainDashboard',
  },
  dashboard_btn3: {
    name: 'Logs',
    key: 'LOGS',
    cssClass: 'portrait-dropped mainDashboard',
  },
  dashboard_btn4: {
    name: 'Shift / Cycle',
    key: 'SHIFT_CYCLE',
    cssClass: 'portrait-dropped mainDashboard',
  },
  dashboard_btn5: {
    name: 'DVIR',
    key: 'DVIR',
    cssClass: 'portrait-dropped mainDashboard',
  },
};

export const requiredKeysDashboard = [
  'dashboard_btn0',
  'dashboard_btn1',
  'dashboard_btn2',
  'dashboard_btn3',
  'dashboard_btn4',
  'dashboard_btn5',
] as const;

export const EditorButtonsDriverOptions: ButtonObjectType[] = [
  {
    name: 'Switch Equipment',
    key: 'EQUIPMENT',
    cssClass: 'dropped driverOptions',
  },
  {
    name: 'Shipping Docs',
    key: 'SHIPPING_DOCS',
    cssClass: 'dropped driverOptions',
  },
  {
    name: 'Remark',
    key: 'REMARK',
    cssClass: 'dropped driverOptions',
  },
  {
    name: 'MANAGE CO-DRIVER(S)',
    key: 'MANAGE_CODRIVER',
    cssClass: 'dropped driverOptions',
  },
  {
    name: 'Gain Time',
    key: 'GAIN_TIME',
    cssClass: 'dropped driverOptions',
  },
  {
    name: 'Exception',
    key: 'EXCEPTION',
    cssClass: 'dropped driverOptions',
  },
  {
    name: 'Data Transfer',
    key: 'DATA_TRANSFER',
    cssClass: 'dropped driverOptions',
  },
  {
    name: 'Split OFF/SB Pairing',
    key: 'SPLIT_OFF_SB_PAIRING',
    cssClass: 'dropped driverOptions',
  },
  {
    name: 'Return to Main Screen',
    key: 'RETURN_TO_HOS',
    cssClass: 'dropped driverOptions',
  },
  {
    name: 'Documents',
    key: 'DOCUMENT',
    cssClass: 'dropped driverOptions',
  }
];

export const defaultTemplateDriverOptions: DriverOptionsLandscapeButtons = {
  options_btn0: {
    name: 'Switch Equipment',
    key: 'EQUIPMENT',
    cssClass: 'dropped driverOptions',
  },
  options_btn1: {
    name: 'Shipping Docs',
    key: 'SHIPPING_DOCS',
    cssClass: 'dropped driverOptions',
  },
  options_btn2: {
    name: 'Remark',
    key: 'REMARK',
    cssClass: 'dropped driverOptions',
  },
  options_btn3: {
    name: 'MANAGE CO-DRIVER(S)',
    key: 'MANAGE_CODRIVER',
    cssClass: 'dropped driverOptions',
  },
  options_btn4: {
    name: 'Gain Time',
    key: 'GAIN_TIME',
    cssClass: 'dropped driverOptions',
  },
  options_btn5: {
    name: 'Exception',
    key: 'EXCEPTION',
    cssClass: 'dropped driverOptions',
  },
  options_btn6: {
    name: 'Data Transfer',
    key: 'DATA_TRANSFER',
    cssClass: 'dropped driverOptions',
  },
  options_btn7: {
    name: 'Split OFF/SB Pairing',
    key: 'SPLIT_OFF_SB_PAIRING',
    cssClass: 'dropped driverOptions',
  },
  options_btn8: {
    name: 'Return to Main Screen',
    key: 'RETURN_TO_HOS',
    cssClass: 'dropped driverOptions',
  },
  options_btn9: {
    name: 'Documents',
    key: 'DOCUMENT',
    cssClass: 'dropped driverOptions',
  },
  options_btn10: {
    name: '',
    key: '',
    cssClass: '',
  },
};

export const requiredKeysDriverOptions = [
  'options_btn0',
  'options_btn1',
  'options_btn2',
  'options_btn3',
  'options_btn4',
  'options_btn5',
  'options_btn6',
  'options_btn7',
  'options_btn8',
  'options_btn9',
] as const;

export function collectUsedButtonKeys(...sections: Array<
  Record<string, ButtonObjectType | undefined> | undefined
>): Set<string> {
  const keys = new Set<string>();

  sections.forEach(section => {
    if (!section) return;
    Object.values(section).forEach(btn => {
      if (btn?.key) {
        keys.add(btn.key);
      }
    });
  });

  return keys;
}

export function filterUnusedEditorButtons(
  palette: ButtonObjectType[],
  usedKeys: Set<string>,
): ButtonObjectType[] {
  return palette.filter(btn => !usedKeys.has(btn.key));
}



export const landscapeDriverOptionsCss = 'dropped driverOptions';
export const landscapeMainDashboardCss = 'dropped mainDashboard';
export const portraitDriverOptionsCss = 'portrait-dropped driverOptions';
export const portraitMainDashboardCss = 'portrait-dropped mainDashboard';

export const emptyButton: ButtonObjectType = {
  name: '',
  key: '',
  cssClass: '',
};

export type ButtonScreenSection = 'driverOptions' | 'mainDashboard';
export type ButtonOrientation = 'landscape' | 'portrait';

/** CanJS dropHandler: "dropped "/"portrait-dropped " + screen section */
export function getPlacedButtonCssClass(
  orientation: ButtonOrientation,
  section: ButtonScreenSection,
): string {
  const prefix =
    orientation === 'portrait' ? 'portrait-dropped' : 'dropped';
  return `${prefix} ${section}`;
}

export function isSlotOccupied(slot?: ButtonObjectType | null): boolean {
  return Boolean(slot?.key || slot?.name);
}

export function placeButton(
  button: ButtonObjectType,
  cssClass: string,
): ButtonObjectType {
  return {
    name: button.name,
    key: button.key,
    cssClass,
  };
}

export function applyCssClassToTemplate<
  T extends Record<string, ButtonObjectType>,
>(template: T, cssClass: string): T {
  const next = { ...template };
  (Object.keys(next) as Array<keyof T>).forEach(key => {
    const btn = next[key] as ButtonObjectType;
    next[key] = (
      btn?.key
        ? { ...btn, cssClass }
        : { ...emptyButton }
    ) as T[keyof T];
  });
  return next;
}

export const defaultLandscapeDashBoard = applyCssClassToTemplate(
  {
    dashboard_btn0: { name: 'Recap', key: 'RECAP', cssClass: '' },
    dashboard_btn1: {
      name: 'Roadside Inspection',
      key: 'ROADSIDE_INSPECTION',
      cssClass: '',
    },
    dashboard_btn2: { name: 'Options', key: 'OPTIONS', cssClass: '' },
    dashboard_btn3: { name: 'Logs', key: 'LOGS', cssClass: '' },
    dashboard_btn4: {
      name: 'Shift / Cycle',
      key: 'SHIFT_CYCLE',
      cssClass: '',
    },
    dashboard_btn5: { name: 'DVIR', key: 'DVIR', cssClass: '' },
  } as DashboardButtons,
  landscapeMainDashboardCss,
);

export const defaultPortraitDashBoard = applyCssClassToTemplate(
  defaultLandscapeDashBoard,
  portraitMainDashboardCss,
);

export const defaultLandscapeDriverOptions = applyCssClassToTemplate(
  defaultTemplateDriverOptions,
  landscapeDriverOptionsCss,
);

export const defaultPortraitDriverOptions = applyCssClassToTemplate(
  {
    ...defaultTemplateDriverOptions,
    options_btn10: { ...emptyButton },
  },
  portraitDriverOptionsCss,
);

export const LAYOUT_PROPERTY_NAME = {
  landscape: 'hos.ui.buttons.layout.landscape',
  portrait: 'hos.ui.buttons.layout.portrait',
} as const;

export const emptyDashboardButtons: DashboardButtons = {
  dashboard_btn0: { ...emptyButton },
  dashboard_btn1: { ...emptyButton },
  dashboard_btn2: { ...emptyButton },
  dashboard_btn3: { ...emptyButton },
  dashboard_btn4: { ...emptyButton },
  dashboard_btn5: { ...emptyButton },
};

export const emptyDriverOptionsButtons: DriverOptionsLandscapeButtons = {
  options_btn0: { ...emptyButton },
  options_btn1: { ...emptyButton },
  options_btn2: { ...emptyButton },
  options_btn3: { ...emptyButton },
  options_btn4: { ...emptyButton },
  options_btn5: { ...emptyButton },
  options_btn6: { ...emptyButton },
  options_btn7: { ...emptyButton },
  options_btn8: { ...emptyButton },
  options_btn9: { ...emptyButton },
  options_btn10: { ...emptyButton },
};

export function getDefaultButtonLayout(
  orientation: ButtonOrientation,
): ButtonLayoutValue {
  if (orientation === 'portrait') {
    return {
      mainDashboard: defaultPortraitDashBoard,
      driverOptions: defaultPortraitDriverOptions,
    };
  }

  return {
    mainDashboard: defaultLandscapeDashBoard,
    driverOptions: defaultLandscapeDriverOptions,
  };
}

function hasRequiredSlots(
  value: unknown,
  keys: readonly string[],
): value is Record<string, ButtonObjectType> {
  if (!value || typeof value !== 'object') {
    return false;
  }

  return keys.every(key => key in (value as object));
}

export function parseButtonLayoutValue(
  value?: string,
): ButtonLayoutValue | null {
  if (!value) {
    return null;
  }

  try {
    const parsed = JSON.parse(value) as Partial<ButtonLayoutValue>;
    const driverOptionSlots = [...requiredKeysDriverOptions, 'options_btn10'];

    if (
      !hasRequiredSlots(parsed.mainDashboard, requiredKeysDashboard) ||
      !hasRequiredSlots(parsed.driverOptions, driverOptionSlots)
    ) {
      return null;
    }

    return {
      mainDashboard: parsed.mainDashboard as DashboardButtons,
      driverOptions: parsed.driverOptions as DriverOptionsLandscapeButtons,
    };
  } catch {
    return null;
  }
}

export function resolveButtonLayout(
  orientation: ButtonOrientation,
  value?: string,
): ButtonLayoutValue {
  return parseButtonLayoutValue(value) ?? getDefaultButtonLayout(orientation);
}

